export const pluralize = (count: number, unitName: string, suffix = "s") => {
  return `${count} ${unitName}${count === 1 ? "" : suffix}`;
};

export const pluralizeForPrefix = (count: number, unitName: string, suffix = "s") => {
  return `${unitName}${count === 1 ? "" : suffix}`;
};
